<template>
  <component
    :is="tag"
    :class="['hh-link', { 'hh-link--accent': accent }]"
    v-bind="linkProps"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
  export default {
    name: 'BaseActionLink',

    props: {
      accent: Boolean,
      href: {
        type: String,
        default: undefined,
      },
      to: {
        type: [String, Object],
        default: undefined,
      },
    },

    computed: {
      tag () {
        return this.to ? 'router-link' : 'a'
      },

      linkProps () {
        if (this.to) return { to: this.to }

        return {
          href: this.href,
          rel: 'noopener',
          target: '_blank',
        }
      },
    },
  }
</script>
